<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-autocomplete
            :validator="$v.form.document_type"
            :external-errors="errors['document_type']"
            :label-form="'Document type' | translate"
            class-form="col-xl-6 my-2"
            labelColsSm="2"
            labelColsLg="2"
            :disabled="!formEditable"
            label-search="name"
            :customize-option="true"
            :value="form.document_type ? { value: form.document_type, name: form.document_type_name } : null"
            :options="documentTypeOptions"
            @search="onSearchDocumentType"
            @select="selectDocumentType"
            @clear="clearDocumentType"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-xl-6 my-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.acronym"
            :external-errors="errors['acronym']"
            :label-form="'Acronym' | translate"
            class-form="col-xl-6 my-2"
            type="text"
            :value="form.acronym"
            :disabled="!formEditable"
            @change="$set(form, 'acronym', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.description"
            :external-errors="errors['description']"
            :label-form="'Description' | translate"
            class-form="col-xl-6 my-2"
            type="text"
            :value="form.description"
            :disabled="!formEditable"
            @change="$set(form, 'description', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-duration
            :validator="$v.form.validity_duration"
            :external-errors="errors['validity_duration']"
            :label-form="'Duration' | translate"
            class-form="col-xl-6 my-2"
            :hours="false"
            type="text"
            :value="form.validity_duration"
            :disabled="!formEditable"
            @change="$set(form, 'validity_duration', $event)"
          />
          <form-thux-horizontal-select
            :validator="$v.form.subtype"
            :external-errors="errors['subtype']"
            :label-form="'Subtype' | translate"
            class-form="col-xl-6 my-2"
            :disabled="!formEditable"
            label-search="text"
            :value="form.subtype ? { value: form.subtype, text: form.get_subtype_display } : null"
            :placeholder="$t('Select an option')"
            :options="subtypeListOptions"
            @select="selectSubtype"
            @clear="clearSubtype"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :validator="$v.form.products"
            label-form="Reference products"
            :class-form="'col-lg-12 my-2'"
            labelColsSm="2"
            labelColsLg="2"
            :external-errors="errors['products']"
            label-search="name"
            :disabled="!formEditable"
            :value="form.products"
            :options="productOptions"
            :placeholder="
              $t('Select a product')
            "
            @search="onSearchProduct"
            @remove="removeProduct"
            @select="selectProduct"
            @clear="$set(form, 'products', null)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :validator="$v.form.security_roles"
            label-form="Security Roles"
            :class-form="'col-lg-12 my-2'"
            labelColsSm="2"
            labelColsLg="2"
            :external-errors="errors['security_roles']"
            label-search="name"
            :disabled="!formEditable"
            :value="form.security_roles"
            :options="securityRoleOptions"
            :placeholder="
              $t('Select a security role')
            "
            @search="onSearchSecurityRole"
            @remove="removeSecurityRole"
            @select="selectSecurityRole"
            @clear="$set(form, 'security_roles', null)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-checkbox
            :validator="$v.form.in_yard_check_list"
            :external-errors="errors['in_yard_check_list']"
            :label-form="'Yard-ITP' | translate"
            class-form="col-xl-2 my-2"
            label-cols-lg="6"
            label-cols-sm="3"
            :value="form.in_yard_check_list"
            :disabled="!formEditable"
            @change="$set(form, 'in_yard_check_list', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.ordering"
            :external-errors="errors['ordering']"
            :label-form="'ITP order' | translate"
            class-form="col-xl-4 my-2"
            label-cols-lg="4"
            label-cols-sm="2"
            type="number"
            :value="form.ordering"
            :disabled="!formEditable"
            @change="$set(form, 'ordering', $event)"
          />
          <form-thux-horizontal-checkbox
            :validator="$v.form.in_yard_evaluation"
            :external-errors="errors['in_yard_evaluation']"
            :label-form="'Yard-Summary' | translate"
            class-form="col-xl-4 my-2"
            label-cols-lg="4"
            label-cols-sm="3"
            :value="form.in_yard_evaluation"
            :disabled="!formEditable"
            @change="$set(form, 'in_yard_evaluation', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-checkbox
            :validator="$v.form.in_contractor_summary"
            :external-errors="errors['in_contractor_summary']"
            :label-form="'Organization summary' | translate"
            class-form="col-xl-2 my-2"
            label-cols-lg="6"
            label-cols-sm="3"
            :value="form.in_contractor_summary"
            :disabled="!formEditable"
            @change="$set(form, 'in_contractor_summary', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.contractor_summary_order"
            :external-errors="errors['contractor_summary_order']"
            :label-form="'Organization summary order' | translate"
            class-form="col-xl-4 my-2"
            label-cols-lg="4"
            label-cols-sm="2"
            type="number"
            :value="form.contractor_summary_order"
            :disabled="!formEditable"
            @change="$set(form, 'contractor_summary_order', $event)"
          />
          <form-thux-horizontal-checkbox
            :validator="$v.form.in_customer_reminder"
            :external-errors="errors['in_customer_reminder']"
            :label-form="'Customer Reminder' | translate"
            class-form="col-xl-4 my-2"
            label-cols-lg="4"
            label-cols-sm="3"
            :value="form.in_customer_reminder"
            :disabled="!formEditable"
            @change="$set(form, 'in_customer_reminder', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-checkbox
            :validator="$v.form.is_security_nomination"
            :external-errors="errors['is_security_nomination']"
            :label-form="'Security Nomination' | translate"
            class-form="col-xl-2 my-2"
            label-cols-lg="6"
            label-cols-sm="3"
            :value="form.is_security_nomination"
            :disabled="!formEditable"
            @change="$set(form, 'is_security_nomination', $event)"
          />
          <form-thux-horizontal-checkbox
            :validator="$v.form.download_for_external"
            :external-errors="errors['download_for_external']"
            :label-form="'Download For External' | translate"
            class-form="col-xl-4 offset-xl-4 my-2"
            label-cols-lg="4"
            label-cols-sm="3"
            :value="form.download_for_external"
            :disabled="!formEditable"
            @change="$set(form, 'download_for_external', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :validator="$v.form.base_certifications"
            :label-form="'Legally equivalent to' | translate"
            :class-form="'col-lg-12 my-2'"
            labelColsSm="2"
            labelColsLg="2"
            :external-errors="errors['base_certifications']"
            label-search="text"
            :disabled="!formEditable"
            :value="form.base_certifications"
            :options="documentOptions"
            :placeholder="
              $t('Select document')
            "
            @search="(search)=>onSearchBaseCertifications(search, id, form.base_certifications)"
            @remove="removeBaseCertification"
            @select="selectBaseCertification"
            @clear="clearBaseCertification"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-multiselect
            :validator="$v.form.courses"
            :label-form="'Associated courses' | translate"
            :class-form="'col-lg-12 my-2'"
            labelColsSm="2"
            labelColsLg="2"
            :external-errors="errors['courses']"
            label-search="text"
            :disabled="!formEditable"
            :value="form.courses"
            :options="coursesOptions"
            :placeholder="
              $t('Select course')
            "
            @search="(search)=>onSearchCourses(search, form.courses)"
            @remove="removeCourse"
            @select="selectCourse"
            @clear="clearCourses"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <div class="mt-3 f-w-600 d-flex justify-content-end">
          <b-button
            class="mr-3"
            variant="default"
            @click.prevent="handleClose">
            {{ formEditable ? 'Cancel' : 'Close' | translate }}
          </b-button>
          <b-button
            variant="primary"
            v-has-perms="editRolePerm"
            @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
            :disabled="$v.form.$invalid">
            {{ formEditable ? 'Save' : 'Edit' | translate }}
          </b-button>
        </div>
      </div>
    </div>
  </panel>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { vue } from '@/main'
import { TYPES as DOCUMENTTYPES } from './store'

import ThuxDetailPanelMixin from '@/components/thux-detail-panel/ThuxDetailPanelMixin'
import DocumentTypeMixin from './mixins/DocumentTypeMixin'
import SubtypeMixin from './mixins/SubtypeMixin'
import ProductMixin from './mixins/ProductMixin'
import SecurityRoleMixin from './mixins/SecurityRoleMixin'
import { storeMixin } from '@/storeMixin'

export default {
  name: 'DocumentEdit',
  mixins: [ThuxDetailPanelMixin, DocumentTypeMixin, SubtypeMixin, ProductMixin, SecurityRoleMixin],
  data () {
    return {
      pageName: 'Document',
      rolePerm: 'document_document_retrieve',
      editRolePerm: ['document_document_update', 'document_documenttype_list'],
      form: {
        in_yard_check_list: false,
        in_yard_evaluation: false,
        in_contractor_summary: false,
        base_certifications: [],
        courses: []
      }
    }
  },
  computed: {
    ...mapGetters({
      ...DOCUMENTTYPES.GENERIC.document.document.DETAIL.GETTERS,
      baseCertificationsList: DOCUMENTTYPES.GENERIC.document.document.LIST.GETTERS.baseCertificationsList,
      coursesList: DOCUMENTTYPES.GENERIC.document.document.LIST.GETTERS.coursesList
    }),
    documentOptions () {
      const options = []
      if (this.baseCertificationsList.results && this.baseCertificationsList.results.length) {
        this.baseCertificationsList.results.forEach(item => {
          options.push({
            value: item.id,
            text: item.name
          })
        })
      }
      return options
    },
    coursesOptions () {
      const options = []
      if (this.coursesList && this.coursesList.length) {
        this.coursesList.forEach(item => {
          options.push({
            value: item.id,
            text: item.name || `${item.title || ''} ${item.subtitle || ''}`.trim()
          })
        })
      }
      return options
    }
  },
  components: { },
  methods: {
    ...mapActions({
      ...DOCUMENTTYPES.GENERIC.document.document.DETAIL.ACTIONS,
      getDocumentList: DOCUMENTTYPES.GENERIC.document.document.LIST.ACTIONS.setFilters,
      refreshDocumentList: DOCUMENTTYPES.GENERIC.document.document.LIST.ACTIONS.getList,
      getCoursesList: DOCUMENTTYPES.GENERIC.document.document.LIST.ACTIONS.setCoursesFilters,
      getBaseCertificationsList: DOCUMENTTYPES.GENERIC.document.document.LIST.ACTIONS.setBaseCertificationsFilters
    }),
    ...mapMutations({
      setDocDetail: DOCUMENTTYPES.GENERIC.document.document.DETAIL.MUTATIONS.setDetail,
      setCoursesList: DOCUMENTTYPES.GENERIC.document.document.LIST.MUTATIONS.setCoursesList,
      setBaseCertificationsList: DOCUMENTTYPES.GENERIC.document.document.LIST.MUTATIONS.setBaseCertificationsList
    }),
    setBaseCertifications (formData) {
      if (this.form.base_certifications) {
        const list = []
        this.form.base_certifications.forEach((row) => list.push(row.value))
        this.$set(formData, 'base_certifications', new Set(list))
      } else {
        this.$set(formData, 'base_certifications', [])
      }
    },
    onSearchBaseCertifications (search, documentId, selectedIds) {
      if (search.length >= 2) {
        vue.$store.commit('componentLoading', false)
        const excludedList = []
        if (documentId) {
          excludedList.push(documentId)
        }
        if (selectedIds && selectedIds.length > 0) {
          excludedList.push(...selectedIds.map(item => item.value))
        }
        const filters = {
          filter__name__icontains: search
        }
        if (excludedList.length > 0) {
          filters.exclude__id__in = excludedList
        }
        this.getBaseCertificationsList(filters).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setBaseCertificationsList({})
      }
    },
    selectBaseCertification (item) {
      const list = this.form.base_certifications || []
      const updated = [...list, item]
      this.$set(this.form, 'base_certifications', updated)
    },
    removeBaseCertification (item) {
      const list = this.form.base_certifications || []
      const updated = list.filter(i => i.value !== item.value)
      this.$set(this.form, 'base_certifications', updated)
    },
    clearBaseCertifications () {
      this.$set(this.form, 'base_certifications', [])
    },
    setCourses (formData) {
      if (this.form.courses) {
        const list = []
        this.form.courses.forEach((row) => list.push(row.value))
        this.$set(formData, 'courses', new Set(list))
      } else {
        this.$set(formData, 'courses', [])
      }
    },
    onSearchCourses (search, selectedIds) {
      if (search.length >= 2) {
        vue.$store.commit('componentLoading', false)
        const excludedList = []
        if (selectedIds) {
          excludedList.push(...selectedIds.map(item => item.value))
        }
        this.getCoursesList({
          filter__name__icontains: search,
          exclude__code__in: excludedList
        }).then(() => {
          vue.$store.commit('componentLoading', true)
        })
      } else {
        this.setCoursesList([])
      }
    },
    selectCourse (item) {
      const list = this.form.courses || []
      const updated = [...list, item]
      this.$set(this.form, 'courses', updated)
    },
    removeCourse (item) {
      const list = this.form.courses || []
      const updated = list.filter(i => i.value !== item.value)
      this.$set(this.form, 'courses', updated)
    },
    clearCourses () {
      this.$set(this.form, 'courses', [])
    },
    initFields () {
      if (!this.id) {
        this.$set(this.form, 'in_contractor_summary', false)
        this.$set(this.form, 'in_yard_check_list', false)
        this.$set(this.form, 'in_yard_evaluation', false)
        this.$set(this.form, 'in_customer_reminder', false)
        this.$set(this.form, 'download_for_external', false)
        this.$set(this.form, 'is_security_nomination', false)
        this.$set(this.form, 'base_certifications', [])
        this.$set(this.form, 'courses', [])
      }
    },
    handleClose () {
      if (this.formEditable) {
        this.cancel()
      } else {
        this.closeForm()
        this.refreshDocumentList()
      }
    },
    cancel () {
      if (!this.id) {
        this.closeForm()
        this.refreshDocumentList()
      } else {
        const form = Object.assign({}, this.detail)
        if (form.products && form.products.length > 0) {
          const filters = {}
          filters.filter__id__in = form.products
          filters.order_by = '-status'
          this.getProductList(filters).then(() => {
            this.$set(form, 'products', this.getProducts(form))
            this.$set(this, 'form', form)
          })
        } else {
          this.$set(this, 'form', form)
        }
        if (form.security_roles && form.security_roles.length > 0) {
          const filters = {}
          filters.filter__id__in = form.security_roles
          filters.order_by = '-status'
          this.getSecurityRoleList(filters).then(() => {
            this.$set(form, 'security_roles', this.getSecurityRoles(form))
            this.$set(this, 'form', form)
          })
        }
        this.formEditable = false
      }
    },
    setForm () {
      if (this.id) {
        const form = Object.assign({}, this.detail)
        if (form.products && form.products.length > 0) {
          const filters = {}
          filters.filter__id__in = [form.products]
          filters.order_by = '-status.-date_create'
          this.getProductList(filters).then(() => {
            this.$set(form, 'products', this.getProducts(form))
            this.$set(this, 'form', form)
          })
        } else {
          this.$set(this, 'form', form)
        }
        if (form.security_roles && form.security_roles.length > 0) {
          const filters = {}
          filters.filter__id__in = [form.security_roles]
          filters.order_by = '-status.-date_create'
          this.getSecurityRoleList(filters).then(() => {
            this.$set(form, 'security_roles', this.getSecurityRoles(form))
            this.$set(this, 'form', form)
          })
        }
      } else {
        this.setDocDetail({ products: [], security_roles: [], base_certifications: [], courses: [] })
      }
    },
    onSubmit () {
      let formData = this.getFormData()
      this.setProducts(formData)
      this.setSecurityRoles(formData)
      this.setBaseCertifications(formData)
      this.setCourses(formData)
      formData = storeMixin.utils.parseFormMultipart(formData, ['file_to_download'])
      const promise = this.id ? this.update(formData) : this.create(formData)
      promise.then(
        () => {
          setTimeout(() => {
            if (!this.id) {
              this.closeForm()
            } else {
              this.makeFormReadonly()
            }
            this.refreshDocumentList()
          }, 500)
        }
      )
    }
  },
  validations: {
    form: {
      document_type: { required },
      subtype: { },
      acronym: { },
      name: { required },
      description: { },
      in_yard_check_list: { },
      in_yard_evaluation: { },
      in_customer_reminder: { },
      download_for_external: { },
      is_security_nomination: { },
      validity_duration: { },
      ordering: { },
      contractor_summary_order: { },
      in_contractor_summary: { },
      base_certifications: { },
      courses: { },
      product: { },
      security_roles: {
        required: requiredIf(function () { return this.form.is_security_nomination })
      }
    }
  }
}
</script>
